import PropTypes from 'prop-types';
import React from 'react';
import { shake } from 'react-animations';
import styled, { keyframes } from 'react-emotion';

import Style from '../../styles/common';

const shakeAnimation = keyframes`${shake}`;

const Container = styled('div')`
  align-items: center;
  color: ${Style.color.ERROR};
  display: flex;
  margin: 15px 0 5px;
  text-align: left;
`;

const Text = styled('span')`
  animation: ${props => props.shouldAnimate && '.65s ' + shakeAnimation};
  font-size: 16px;
  line-height: 1.5;
`;

export default function ErrorMessage(props) {
  return (
    <Container>
      <Text shouldAnimate={props.shouldAnimate}>{props.children}</Text>
    </Container>
  );
}

ErrorMessage.propTypes = {
  children: PropTypes.node.isRequired,
  shouldAnimate: PropTypes.bool,
};

ErrorMessage.defaultProps = {
  shouldAnimate: false,
};



// WEBPACK FOOTER //
// ./src/components/Messages/ErrorMessage.js